import { ITemplate } from '../models/ITemplate';
import { Module } from '../Module';

interface ITemplateListScope extends ng.IScope {
  templates: ITemplate[];
}

class TemplateListCtrl {
  public templates: ITemplate[] = [];
}

Module.instance().directive('tbTemplateList', () => {
  return {
    require: 'tbTemplateList',
    restrict: 'E',
    controller: TemplateListCtrl,
    scope: {
      templates: '=?'
    },
    link: (
      scope: ITemplateListScope,
      element: JQuery,
      attrs: ng.IAttributes,
      templateListCtrl: TemplateListCtrl
    ) => {
      scope.templates = templateListCtrl.templates;
      element.remove();
    }
  };
});

Module.instance().directive('tbTemplate', () => {
  return {
    require: '^tbTemplateList',
    restrict: 'E',
    transclude: true,
    link: (
      scope: ng.IScope,
      element: JQuery,
      attrs: ng.IAttributes,
      templateListCtrl: TemplateListCtrl,
      transclude: ng.ITranscludeFunction
    ) => {

      const ifExpression = attrs['templateIf'];

      if (ifExpression === undefined || scope.$eval(ifExpression)) {
        templateListCtrl.templates.push({ attrs: attrs, linkFn: transclude });
      }
    }
  };
});
